<template>
    <div class="panel">
        <div class="image-row">
            <img
                class="image col"
                src="@/assets/img/contamination-details.svg"
            >
            <div class="legend">
                <div class="item">
                    <span class="circle Yes" />Yes
                </div>
                <div class="item">
                    <span class="circle No" />No
                </div>
                <div class="item">
                    <span class="circle Unknown" />Unknown
                </div>
            </div>
        </div>
        <h3 class="table-title">
            Contaminant Description<br>(AH Preferred Code)
        </h3>
        <div class="table">
            <div class="row">
                <div class="title" />
                <div class="data">
                    <div class="sideways-title">
                        Impacted groundwater
                    </div>
                </div>
                <div class="data">
                    <div class="sideways-title">
                        Impacted surface water
                    </div>
                </div>
                <div class="data">
                    <div class="sideways-title">
                        Impacted soil on-site
                    </div>
                </div>
                <div class="data">
                    <div class="sideways-title">
                        Impacted soil off-site
                    </div>
                </div>
            </div>
            <div
                v-for="row in siteDetails.contaminants"
                :key="row.description"
                class="row"
            >
                <div class="title indented">
                    {{ row.description }}
                </div>
                <div class="data">
                    <span :class="'circle ' + row.isGroundWaterImpacted" />
                </div>
                <div class="data">
                    <span :class="'circle ' + row.isSurfaceWaterImpacted" />
                </div>
                <div class="data">
                    <span :class="'circle ' + row.isOnSiteSoilImpacted" />
                </div>
                <div class="data">
                    <span :class="'circle ' + row.isOffSiteSoilImpacted" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

export default defineComponent({
    name: 'ContaminationDetails',
    components: {},
    props: {
        siteDetails: ESARSite
    },
    setup() {
        const data = [
            { title: 'Hydrocarbon', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Benzene ', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Toluene', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Ethylbenzene', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Xylenes', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F1 (F1)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F2 (F2)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F3 (F3)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F4 (F4)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Lead (Pb)', values: ['yes', 'no', 'yes', 'unknown'], },
        ];

        return { data };
    }
});
</script>

<style lang="postcss" scoped>
.panel {
    .image-row {
        @apply flex relative;
        width: 500px;

        .image {
            @apply w-full;
        }

        .legend {
            @apply absolute;
            right: 50px;
            top: 10px;

            .item {
                @apply flex items-center mb-2;
            }
        }
    }

    .table-title {
        @apply font-bold mt-10;
    }

    .table {
        @apply flex flex-col;

        .row {
            @apply flex;
        }

        .title {
            @apply w-2/5
        }

        .data {
            @apply w-12;
        }

        .indented {
            @apply pl-4;
        }

        .sideways-title {
            @apply w-full whitespace-pre font-bold;
            transform: rotate(-25deg) translate(5px, -10px);
        }
    }

    .circle {
        @apply w-6 h-6 rounded-full inline-block text-center mr-1;

        &.Yes {
            @apply bg-report-circle-yes;
        }

        &.No {
            @apply bg-report-circle-no;
        }

        &.Unknown {
            @apply border;
            border-color: #252828;

            &:after {
                content: '?'
            }
        }
    }
}
</style>
